import { create } from 'zustand';

interface NovaState {
  isOpen: boolean;
  keyUnlocked: boolean;
  open: () => void;
  close: () => void;
  setKeyUnlocked: (v: boolean) => void;
}

export const useNovaStore = create<NovaState>((set) => ({
  isOpen: false,
  keyUnlocked: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  setKeyUnlocked: (v) => set({ keyUnlocked: v }),
}));
